<template>
  <div class="animated fadeInRight ecommerce">
    <el-row>
      <el-col :span="24">
        <el-card>
          <div slot="header" class="flex justify-between">
            <span>DEMO信息</span>
            <div>
              <el-button type="primary" size="small" @click="_openAddOwnerModal(-1)">
                <i class="el-icon-plus"></i>
                添加DEMO
              </el-button>
            </div>
          </div>

          <el-table
            :data="listDemoInfo.demos"
            style="width: 100%"
            border
            stripe
          >
            <el-table-column prop="demoId" label="用例ID"></el-table-column>
            <el-table-column prop="demoName" label="名称"></el-table-column>
            <el-table-column prop="demoValue" label="用例值"></el-table-column>
            <el-table-column prop="demoRemark" label="备注"></el-table-column>
            <el-table-column label="操作" align="right" width="200">
              <template slot-scope="scope">
                <el-button-group>
                  <el-button size="mini" @click="_openEditOwnerModel(scope.row)">修改</el-button>
                  <el-button size="mini" type="danger" @click="_openDelOwnerModel(scope.row)">删除</el-button>
                </el-button-group>
              </template>
            </el-table-column>
          </el-table>

          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="pageSize"
            layout="total, prev, pager, next, jumper"
            :total="listDemoInfo.total"
            style="margin-top: 20px; float: right;"
          >
          </el-pagination>
        </el-card>
      </el-col>
    </el-row>

    <add-demo ref="addDemo"></add-demo>
  </div>
</template>

<script>
import { getDemoList } from '@/api/dev/demoApi'
import AddDemo from '@/components/dev/addDemo/addDemo.vue'

export default {
  name: 'ListDemo',
  components: {
    AddDemo
  },
  data() {
    return {
      listDemoInfo: {
        demos: [],
        total: 0,
        records: 1
      },
      currentPage: 1,
      pageSize: 10
    }
  },
  created() {
    this._listOwnerData(this.currentPage, this.pageSize)
  },
  methods: {
    handleCurrentChange(val) {
      this.currentPage = val
      this._listOwnerData(val, this.pageSize)
    },
    async _listOwnerData(page, row) {
      try {
        const res = await getDemoList({ page, row })
        this.listDemoInfo.demos = res.data
        this.listDemoInfo.total = res.total
        this.listDemoInfo.records = res.records
        console.log(this.listDemoInfo.records)
      } catch (error) {
        console.error('获取DEMO列表失败:', error)
      }
    },
    _openAddOwnerModal() {
      this.$refs.addDemo.open()
    },
    _openDelOwnerModel(owner) {
      // 待实现删除逻辑
      console.log('删除:', owner)
    },
    _openEditOwnerModel(owner) {
      // 待实现编辑逻辑
      console.log('编辑:', owner)
    }
  }
}
</script>

<style scoped>
.el-row, .el-col {
  width: 100%;
}
</style>